
<script setup lang="ts">
import { Icon } from '@iconify/vue'
import type { OneNetworkMenuGroupItem } from '@/onenetwork/interfaces/onenetwork.interface.menu'
import AllowPerm from '@/onenetwork/components/perms/AllowPerm.vue'
import { computed, ref } from 'vue'
import { useOneNetworkMenuStore } from '@/onenetwork/stores/onenetwork.store.menu.ts'
import { uuid } from 'vue3-uuid'

const OneNetworkMenuStore = useOneNetworkMenuStore()

const props = withDefaults(defineProps<OneNetworkMenuGroupItem>(), {
  perm: [],
  heading: '',
  collapsed: false,
  items: () => []
})

const collapsed = computed(() => {
  return OneNetworkMenuStore.collapsed.includes(props.heading)
})

// const collapsed = ref<boolean>(false)

const handleToggleCollapse = (e: any) => {
  OneNetworkMenuStore.toggleCollapsed(props.heading)
}
</script>

<template>
    <div class="menu-heading flex justify-between" v-if="props.heading">
      <span>{{props.heading}}</span>
      <span class="cursor-pointer color-[#525252] hover:color-[#FF0000]" @click="handleToggleCollapse">
        <Icon icon="ph:caret-up-thin" height="16" v-if="!collapsed"/>
        <Icon icon="ph:caret-down-thin" height="16" v-else/>
      </span>
    </div>
    <ul class="menu-list" v-if="!collapsed">
<!--      <template v-for="(item, index) in props.items" :key="index">-->
<!--        <allow-perm :perm="item.perm" >-->
<!--          <li :class="`menu-item ${props?.currentRoute?.length > 0 && item.path.includes('/' + props.currentRoute[0]) ? 'active' : ''}`">-->
<!--            <router-link :to="item.path" class="menu-link">-->
<!--              <Icon class="icon" :icon="item.icon" v-if="item.icon"/>-->
<!--              <span>{{ item.name }}</span>-->
<!--            </router-link>-->
<!--            <ul v-if="Array.isArray(item.child) && item.child.length > 0" class="submenu">-->
<!--              <li v-for="(childItem, index) in item?.child" :key="index" :class="`submenu-item ${props?.currentRoute?.length > 0 && childItem.path.includes('/' + props.currentRoute.join('/')) ? 'active' : ''}`">-->
<!--                <router-link :to="childItem.path" class="submenu-link">-->
<!--                  <Icon class="icon" :icon="childItem.icon" v-if="childItem.icon"/>-->
<!--                  <span>{{ childItem.name }}</span>-->
<!--                </router-link>-->
<!--              </li>-->
<!--            </ul>-->
<!--          </li>-->
<!--        </allow-perm>-->
<!--      </template>-->
      <!-- {{ props.items }} -->
      <template v-for="(item, index) in props.items" :key="index">
        <allow-perm :perm="item.perm" >
          <li :class="`menu-item`" :data-path="item.path">
            <router-link :to="item.path" class="menu-link">
              <Icon class="icon" :icon="item.icon" v-if="item.icon"/>
              <span>{{ item.name }}</span>
            </router-link>
            <ul v-if="Array.isArray(item.child) && item.child.length > 0" class="submenu">
              <li v-for="(childItem, index) in item?.child" :key="index" :class="`submenu-item`">
                <router-link :to="childItem.path" class="submenu-link">
                  <Icon class="icon" :icon="childItem.icon" v-if="childItem.icon"/>
                  <span>{{ childItem.name }}</span>
                </router-link>
              </li>
            </ul>
          </li>
        </allow-perm>
      </template>
    </ul>
</template>

<style scoped>

</style>
